import type { PlaneFinderState } from './usePlaneFinder';

const HINTS: Record<string, string> = {
  view: 'Tap a flat surface',
  detecting: 'Finding the surface…',
  framing: 'Adjust the frame',
  capturing: 'Capturing…',
};

/** Minimal top-center contextual hint; errors (load/capture failures) take priority. */
export function Hud({ state }: { state: PlaneFinderState }) {
  if (state.error) return <div className="pf-hint pf-hint-error">{state.error}</div>;
  // The "preparing" state has its own centered overlay (PreparingOverlay), so the
  // top pill stays out of the way until detection is ready.
  if (state.stage === 'view' && !state.analysisReady) return null;
  const hint = HINTS[state.stage];
  if (!hint) return null;
  return <div className="pf-hint">{hint}</div>;
}
